module.exports = __webpack_public_path__ + "static/media/reviews.d8096034.png";